import { create } from 'zustand';
import { correctAnswersReducer } from 'pathfinder/modules/shared/QuizConsumption/helpers/ResultsHelper';
import { deleteQuestion, deletePreviouslyReportedQuestions, randomizeAnswers, deleteAnswersToReportedQuestions, } from 'pathfinder/utils/quizHelper';
import { getReportedQuestionsCount, saveReportedQuestion, } from 'pathfinder/modules/QuizConsumptionModule/helpers/reportedQuestionsHelper';
export var QuizScreenState;
(function (QuizScreenState) {
    QuizScreenState["TitleScreen"] = "TitleScreen";
    QuizScreenState["InProgress"] = "InProgress";
    QuizScreenState["Completed"] = "Completed";
})(QuizScreenState || (QuizScreenState = {}));
export var QuizDataLoadingState;
(function (QuizDataLoadingState) {
    QuizDataLoadingState["Error"] = "Error";
    QuizDataLoadingState["Initial"] = "Initial";
    QuizDataLoadingState["Loaded"] = "Loaded";
    QuizDataLoadingState["Loading"] = "Loading";
})(QuizDataLoadingState || (QuizDataLoadingState = {}));
const initialState = {
    quizData: undefined,
    currentQuestionIndex: -1,
    initialQuestionIndex: -1,
    userQuizAnswers: [],
    quizScreenState: QuizScreenState.TitleScreen,
    quizDataLoadingState: QuizDataLoadingState.Initial,
    questionTimer: 10,
    reportedQuestionsCount: 0,
};
export const useQuizStore = create((set, get) => (Object.assign(Object.assign({}, initialState), { 
    // selectors
    getQuizQuestions: () => { var _a, _b; return (_b = (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.questions) !== null && _b !== void 0 ? _b : []; }, getCurrentQuizQuestion: () => { var _a, _b; return (_b = (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.questions) === null || _b === void 0 ? void 0 : _b[get().currentQuestionIndex]; }, getCreatorId: () => { var _a; return (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.creatorId; }, getQuizDiscussionId: () => { var _a; return (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.discussionId; }, getQuizTitle: () => { var _a; return (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.title; }, getQuizImage: () => { var _a; return (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.image; }, getQuizId: () => { var _a, _b; return (_b = (_a = get().quizData) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1; }, getNumberOfCorrectQuizQuestions: () => get().userQuizAnswers.reduce(correctAnswersReducer, 0), isGenAIQuiz: () => { var _a; return !!((_a = get().quizData) === null || _a === void 0 ? void 0 : _a.isGenai); }, 
    // set actions
    setNextQuiz: (quiz) => set(() => ({
        currentQuestionIndex: 0,
        quizScreenState: QuizScreenState.TitleScreen,
        userQuizAnswers: [],
        quizDataLoadingState: QuizDataLoadingState.Loaded,
        quizData: randomizeAnswers(deletePreviouslyReportedQuestions(quiz)),
        reportedQuestionsCount: 0,
    })), resetQuiz: () => set(() => ({
        currentQuestionIndex: 0,
        quizScreenState: QuizScreenState.TitleScreen,
        userQuizAnswers: [],
    })), setQuizDataLoadingState: (loadingState) => set(() => ({ quizDataLoadingState: loadingState })), setInitialQuestionIndex: (questionIndex) => set(() => ({
        currentQuestionIndex: questionIndex,
        initialQuestionIndex: questionIndex,
    })), nextQuestionIndex: (tracker) => set((state) => {
        if (state.currentQuestionIndex >= state.quizData.questions.length - 1) {
            if (tracker === null || tracker === void 0 ? void 0 : tracker.onQuizCompleteImpression) {
                tracker.onQuizCompleteImpression();
            }
            else {
                console.error('nextQuestionIndex was not supplied with an onQuizCompleteImpression.');
            }
            return { quizScreenState: QuizScreenState.Completed };
        }
        return { currentQuestionIndex: state.currentQuestionIndex + 1 };
    }), previousQuestionIndex: () => set((state) => ({
        currentQuestionIndex: state.currentQuestionIndex - 1,
    })), setQuizScreenState: (screenState) => set(() => ({
        quizScreenState: screenState,
    })), setPreloadedUserQuizAnswers: (answers) => {
        if (answers) {
            set(() => ({ userQuizAnswers: answers }));
        }
    }, setUserQuizAnswer: (answer) => set((state) => ({
        userQuizAnswers: [...state.userQuizAnswers, answer],
    })), setManuallyLoadedQuizData: (quiz) => set(() => ({
        quizData: randomizeAnswers(deletePreviouslyReportedQuestions(quiz)),
        reportedQuestionsCount: getReportedQuestionsCount(quiz.id.toString()),
        quizDataLoadingState: QuizDataLoadingState.Loaded,
    })), setQuizTimer: (timer) => set(() => ({
        questionTimer: timer,
    })), setReportedQuestions: (quizId, questionId) => {
        set((state) => ({
            reportedQuestionsCount: state.reportedQuestionsCount + 1,
            quizData: deleteQuestion(state.quizData, questionId),
            userQuizAnswers: deleteAnswersToReportedQuestions(state.userQuizAnswers, questionId),
        }));
        saveReportedQuestion(quizId.toString(), questionId);
    } })));
